import axios from "axios";

// ---- Pricing ----
export const getPricingGTL = () => {
  // GET https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gtl
  return axios.get(
    "https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gtl"
  );
};

export const getPricingGPA = () => {
  // GET https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gpa
  return axios.get(
    "https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/pricing-gpa"
  );
};

// ---- OTP ----
export const generateOTP = (phoneNumber) => {
  // POST https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/generate-otp?phoneNumber={phoneNumber}
  return axios.post(
    `https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/generate-otp?phoneNumber=${phoneNumber}`
  );
};

export const verifyOTP = (phoneNumber, otp) => {
  // POST https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/verify-otp?phoneNumber={phoneNumber}&otp={otp}
  return axios.post(
    `https://flashaid-v3-prod-backend.flashaid.in/auth/v1/tirumala/verify-otp?phoneNumber=${phoneNumber}&otp=${otp}`
  );
};

// ---- Submit ----
export const singleUpload = (formPayload) => {
  // POST https://flashaid-v3-prod-backend.flashaid.in/auth/v1/customer-insurance/tirumala/single-upload

  return axios.post(
"https://flashaid-v3-dev-backened.flashaid.in/auth/v1/customer-insurance/tirumala/single-upload",
    formPayload
  );
};

// ---- Reports -----

export const getRepeatedLoansReport = (startDate, endDate) => {
  // GET https://flashaid-v3-dev-backened.flashaid.in/auth/v1/customer-insurance/tirumala/repeated-loans/excel?startDate=...&endDate=...

  console.log(startDate,endDate)
  return axios.get(
    "https://flashaid-v3-dev-backened.flashaid.in/auth/v1/customer-insurance/tirumala/repeated-loans/excel",
    {
      headers: { "Content-Type": "application/json" },
      params: { startDate, endDate },
    }
  );
};

//---- Get user details through aadhar ----

const BASE = "https://flashaid-v3-dev-backened.flashaid.in/auth/v1/customer-insurance/tirumala";

// No-auth axios instance (won't inherit your global Authorization interceptors)
const noAuth = axios.create({
  baseURL: BASE,
  headers: {}, // keep empty to avoid auth headers
});

// GET user by Aadhaar (expects dashed format: 1234-5678-9014)
export const fetchUserByAadhar = (aadharWithDashes, options = {}) => {
  return noAuth.get(`/get-user/aadhar/${aadharWithDashes}`, { signal: options.signal });
};

//----update the loans----

const BASE_URL = "https://flashaid-v3-dev-backened.flashaid.in";

export const apiClient = axios.create({
  baseURL: BASE_URL,
  // No auth header needed for these endpoints per your note
});

export const updateLoanDetails = (payload) => {
  // payload: { aadhar: "1234-5678-9014", flashcode: "FAS1000-75147", loanDetails: [...] }
  console.log(payload)
  return apiClient.put(
    "/auth/v1/customer-insurance/tirumala/user/loan-details/insert",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
};

export const updateLoanStatus = async ({ loanId, faid, status, statusDate }) => {
  try {
    const params = { id: loanId, faid, status };
    if (statusDate) params.statusDate = statusDate; // YYYY-MM-DD

    const res = await axios.put(
      `https://flashaid-v3-dev-backened.flashaid.in/auth/v1/customer-insurance/tirumala/update-loan/status`,
      {}, // body empty by design
      {
        params,
        headers: { "Content-Type": "application/json" },
      }
    );
    return res;
  } catch (err) {
    // Throw a richer error so caller can show backend message
    const message = err?.response?.data?.message || err?.message || "Failed to update loan status";
    const toThrow = new Error(message);
    toThrow.original = err;
    throw toThrow;
  }
};